<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar>
      <v-img
        :src="
          require('@/assets/vmd.svg')"
      />
    </v-list-item-avatar>

    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h3">
        <strong class="mr-1 font-weight-black">صندوق</strong>
        &nbsp;
        <span class="primary--text">یار</span>
        <div class="text-h6">
          پنل کاربری
        </div>
        <user-full-name />
        <user-personal-code />
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'
  import UserFullName from '@/components/username'
  import UserPersonalCode from '@/components/personalcode'

  export default {
    name: 'DefaultDrawerHeader',
    components: {
      UserFullName,
      UserPersonalCode,
    },
    computed: {
      version: get('app/version'),
    },
  }
</script>
